

































































































import { defineComponent, reactive, ref } from '@vue/composition-api';

const CreateExpense = defineComponent({
  setup() {
    const type = ref(0);
    const driverDropdown = {
      display: ['driver1', 'driver2', 'driver3'],
      value: [0, 1, 2],
      selected: 0,
    };
    const accountDropdown = {
      display: ['acc1', 'acc2', 'acc3'],
      value: [0, 1, 2],
      selected: 0,
    };
    const typeDropdown = {
      display: ['type1', 'type2', 'type3'],
      value: [0, 1, 2],
      selected: 0,
    };
    const info = reactive({
      name: '',
      amount: '',
    });
    return {
      driverDropdown,
      accountDropdown,
      typeDropdown,
      info,
      type,
    };
  },
});

export default CreateExpense;
